// extracted by mini-css-extract-plugin
module.exports = {"block_padding":"12px","list":"_29cfZ5ccF_mW","item":"_2FI2nHTAFmO_"};